import {
  Activity,
  BarChart3,
  BookOpen,
  Boxes,
  FileBarChart,
  GitBranch,
  Gauge,
  ScrollText,
  Server,
  Users,
} from 'lucide-react';
import { AppShell, ThemeToggle, type NavItemConfig } from '../../ui';
import { useTheme } from '../../context/ThemeContext';
import { OperatorMenu } from './OperatorMenu';

// The protected admin layout: Cortex AppShell (collapsible sidebar + sticky blurred header +
// scrollable content) wrapping the route Outlet. Clients (C27), Providers/Policies/Quotas (C28),
// and the live Usage dashboard + Audit log (C29) make up the full operator console.

const NAV_ITEMS: NavItemConfig[] = [
  {
    to: '/clients',
    label: 'Clients',
    description: 'Tenancy & API keys',
    icon: Users,
  },
  {
    to: '/providers',
    label: 'Providers',
    description: 'Routing & health',
    icon: Server,
  },
  {
    to: '/models',
    label: 'Models',
    description: 'Canonical catalog',
    icon: Boxes,
  },
  {
    to: '/policies',
    label: 'Policies',
    description: 'Routing order',
    icon: GitBranch,
  },
  {
    to: '/quotas',
    label: 'Quotas',
    description: 'Rate & capacity',
    icon: Gauge,
  },
  {
    to: '/reports/quotas',
    label: 'Reports',
    description: 'Monthly budgets',
    icon: FileBarChart,
  },
  {
    to: '/usage',
    label: 'Usage',
    description: 'Live telemetry',
    icon: BarChart3,
  },
  {
    to: '/audit',
    label: 'Audit',
    description: 'Change history',
    icon: ScrollText,
  },
  {
    to: '/docs',
    label: 'Docs',
    description: 'API & availability',
    icon: BookOpen,
  },
];

function Brand() {
  const { theme } = useTheme();
  const isDark = theme === 'dark';
  return (
    <div className="flex items-center gap-2.5">
      <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-indigo-500 to-purple-600 shadow-lg shadow-indigo-500/25">
        <Activity className="h-5 w-5 text-white" aria-hidden="true" />
      </span>
      <span className="flex min-w-0 flex-col">
        <span
          className={`text-[10px] font-medium uppercase leading-none tracking-widest ${
            isDark ? 'text-white/40' : 'text-slate-400'
          }`}
        >
          DreamWalk
        </span>
        <span
          className={`-mt-px truncate text-base font-bold leading-tight tracking-tight ${
            isDark ? 'text-white' : 'text-slate-900'
          }`}
        >
          AI Proxy
        </span>
      </span>
    </div>
  );
}

export function AdminLayout() {
  return (
    <AppShell
      navItems={NAV_ITEMS}
      pageTitle="Admin console"
      brand={<Brand />}
      sidebarFooter={<OperatorMenu />}
      headerActions={<ThemeToggle />}
    />
  );
}
